/**
 * Webinar-Detailseite der Sektion „Anfos & Umsatz" (/auswertungen/webinare/:webinarId). Daten über
 * /api/auswertungen/webinare/:id/* (Gruppe fit_products) — dieselben Service-Aufrufe wie die alte
 * Seite, aber ohne 403 für Nutzer nur mit fit_products (Plan § Approach 7). Geld netto (ohne MwSt.):
 * der Router stellt die Geldbasis des Services um, Anzahlen bleiben identisch mit der alten Seite.
 */
import { FC } from 'react';
import WebinarDetail, { WebinarDetailQuelle } from './WebinarDetail';
import {
  fetchDetailAnfos,
  fetchDetailEngagement,
  fetchDetailGruppierung,
  fetchDetailRaum,
  fetchDetailVergleich,
  fetchDetailRegistrierungen,
  fetchDetailZuordnung,
  fetchDetailBezugsart,
  fetchDetailKennzahlen,
  fetchTeilnahme,
  fetchTypischVorTermin,
} from '../../../helpers/auswertungenData';

const QUELLE: WebinarDetailQuelle = {
  engagement: fetchDetailEngagement,
  anfos: fetchDetailAnfos,
  registrierungen: fetchDetailRegistrierungen,
  zuordnung: fetchDetailZuordnung,
  gruppierung: fetchDetailGruppierung,
  raum: fetchDetailRaum,
  vergleich: fetchDetailVergleich,
  bezugsart: fetchDetailBezugsart,
  zurueck: '/auswertungen/webinare-produkte',
  geldbasis: 'netto',
  // P1-Umbau (P1-V3 § 2.8): Sektions-Darstellung; die alte Seite setzt den Schalter nicht.
  sektion: true,
  kennzahlen: fetchDetailKennzahlen,
  teilnahme: fetchTeilnahme,
  // „typisch" an den Termin-Kacheln: die 12 Monate VOR dem Termin (Plan 2026-10-30-vergleichsfenster-drift).
  typisch: fetchTypischVorTermin,
};

const AuswertungenWebinarDetail: FC = () => <WebinarDetail quelle={QUELLE} />;

export default AuswertungenWebinarDetail;
